import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/resources/AssetRegisterReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'fixed', label: 'Fixed' },
  { value: 'non_fixed', label: 'Non-Fixed' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'description', label: 'Description' },
  { key: 'asset_tag', label: 'Asset Tag' },
  { key: 'asset_type', label: 'Type' },
  { key: 'category', label: 'Category' },
  { key: 'department', label: 'Department' },
  { key: 'location', label: 'Location' },
  { key: 'brand', label: 'Brand' },
  { key: 'serial_number', label: 'Serial #' },
  { key: 'purchase_value', label: 'Cost', align: 'right', type: 'money' },
  { key: 'purchase_date', label: 'Purchased' },
  { key: 'vendor', label: 'Vendor' },
  { key: 'useful_life_years', label: 'Useful Life (Yrs)', align: 'right' },
  { key: 'accumulated_depreciation', label: 'Accum. Depn', align: 'right', type: 'money' },
  { key: 'net_book_value', label: 'NBV', align: 'right', type: 'money' },
  { key: 'custodian', label: 'Custodian' },
  { key: 'disposed_at', label: 'Disposed' },
];

export function AssetRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Asset Register"
      description="Full asset listing with category, department, value and vendor."
      endpoint="/reports/resources/asset-register"
      columns={COLUMNS}
      filters={['status', 'category', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      categoryOptions={listOptions(lists, 'asset_category')}
    />
  );
}
